import { Component, Input, OnInit } from '@angular/core';
import { BackendTimeInterface } from '@core/interfaces/backend-time.interface';
import { TEXT_NOT_AVAILABLE, TITLE_NOT_AVAILABLE } from '@core/layouts/default/default.config';
@Component({
  selector: 'shell-out-office',
  templateUrl: './out-office.component.html',
  styleUrls: ['./out-office.component.scss'],
})
export class OutOfTimeComponent implements OnInit {
  constructor() {}

  messageDefault: string = TITLE_NOT_AVAILABLE;
  textDefault: string = TEXT_NOT_AVAILABLE;
  @Input() outOfficeData: BackendTimeInterface = {
    isAvailable: false,
    allowedSchedule: false,
    message: '',
  };

  ngOnInit() {}

  // goToPichincha(): void {
  //   const a: HTMLAnchorElement = document.createElement('a');
  //   a.href =
  //     'https://www.pichincha.pe/ofertas/compra-deuda/?utm_source=zonadigital&utm_medium=link_fueraoficina&utm_campaign=derivacion_fuera_oficina';
  //   a.target = '_blank';
  //   a.click();
  // }
}
